<template>
<el-container>
<el-header class="header">
<el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/' }" style="font-size: 16px;">Home</el-breadcrumb-item>
    <el-breadcrumb-item style="font-size: 16px;">Search</el-breadcrumb-item>
    <el-breadcrumb-item style="font-size: 16px;">Enhancer List</el-breadcrumb-item>
</el-breadcrumb>
</el-header>
<el-aside width="3px"></el-aside>
<el-main>
<el-container>
    <el-aside class="aside">
    <div>
        <Listselect @search="handleSearch" />
    </div>
    </el-aside>
    <el-main>
        <!-- <div :key="selectedType+selectedSpecies + selectedTissue"> 中的 :key 用于确保在切换不同条件时，Vue 能正确地更新和重新渲染组件 -->
        <div :key="selectedType+selectedSpecies + selectedTissue">
            <!-- 根据不同的 selectedType 条件显示不同的组件 -->
            <Telist v-if="selectedType === 'Typical-Enhancer'" :species="selectedSpecies" :tissue="selectedTissue" />
            <Selist v-else-if="selectedType === 'Super-Enhancer'" :species="selectedSpecies" :tissue="selectedTissue" />
            <Hublist v-else-if="selectedType === 'Individual-Enhancer'" :species="selectedSpecies" :tissue="selectedTissue" />
        </div>
    </el-main>
</el-container>
</el-main>
<el-aside width="3px"></el-aside>
</el-container>
</template>

<script>
import Listselect from '../List/Listselect.vue';
import Selist from '../seAnalysis/Selist.vue';
import Hublist from '../hubAnalysis/Hublist.vue';
import Telist from '../teAnalysis/Enlist.vue';

export default {
    components: {
        Listselect,
        Selist,
        Hublist,
        Telist
    },
    data() {
        return {
            selectedType: '',
            selectedSpecies: '',
            selectedTissue: ''
        };
    },
    created() {
        // 在组件创建时，设置默认参数值
        this.selectedType = 'Individual-Enhancer';
        this.selectedSpecies = 'human';
        this.selectedTissue = 'DE';
    },
    methods: {
        handleSearch(params) {
            this.selectedType = params.Type;
            this.selectedSpecies = params.Species;
            this.selectedTissue = params.Tissue;
        }
    }
};
</script>

<style scoped>
.header {
    padding: 0px;
    border-bottom: 1px solid #ccc;
    height: 40px;
    display: flex;
    align-items: center;
    margin-left: 20px;
    margin-top: 60px;
}
.aside {
    width: 240px;
    border-right: 1px dashed #ccc;
}
</style>


// WEBPACK FOOTER //
// src/components/search/List.vue